/* eslint-disable linebreak-style */
import React from 'react';

const Header = () => (
  <header className="masthead text-white text-center">
    <img
      src="public/img/lilly.png"
      alt="lilly-logo"
      style={{
        position: 'absolute', top: '25px', left: '50px', width: '100px',
      }}
    />
    {/* <div className="overlay"></div> */}
    <div className="container">
      <div className="row">
        <div className="col-xl-12 mx-auto">
          <img src="public/img/PARM_logo_WO.png" alt="Parm_Logo" width="200px" />
          {/* eslint-disable-next-line max-len */}
          <h1 style={{ fontSize: '20px', marginTop: '15px' }}>
            A health management tool created by Lilly for
            <br />
            healthcare providers caring for people with diabetes
          </h1>
        </div>

      </div>
    </div>
  </header>
);

export default Header;
